/*
 * @Description: 案例审核筛选项
 * @Author: hanpengtao
 * @Date: 2022-04-25 11:26:59
 */
import React from 'react';
import { Select, Input, DatePicker, Button, message } from 'antd';
import { useSetState } from 'ahooks';
import ClassifyCascader from '@/component/ClassifyCascader/index';
import './index.less';

const { Option } = Select;
const { RangePicker } = DatePicker;

const reg = /^\d+(\.\d+)?$/;
const timeStyle = 'YYYY-MM-DD HH:mm:ss';

const listStatusArr = [
  {
    id: null,
    name: '全部',
  },
  {
    id: '0',
    name: '未审核',
  },
  {
    id: '1',
    name: '已审核',
  },
  {
    id: '2',
    name: '审核不通过',
  },
  // {
  //   id: '3',
  //   name: '已下架',
  // }
];
const listSourceArr = [
  // {
  //   id: '',
  //   name: '全部',
  // },
  {
    id: 0,
    name: '自营爬取',
  },
  {
    id: 1,
    name: '用户上传',
  },
  {
    id: 2,
    name: '运营导入',
  }
];

const authorizationTypeArr = [
  {
    id: null,
    name: '全部',
  },
  {
    id: 1,
    name: '独家',
  },
  {
    id: 2,
    name: '非独家',
  }
];

const getInitParams = () => ({
  caseId: null,  // 案例id
  classifyId: null,  // 分类id
  reviewStatus: '0',  // 状态
  reviewAccountId: null,  // 审核人id
  title: null,  // 标题关键字
  authorizationType: null, // 来源
  sourceType: 0, // 来源
  startTime: '', // 案例发布时间
  endTime: '',  // 案例发布时间
  reviewStartTime: '', // 审核日期
  reviewEndTime: '', // 审核日期
})

const getInitOwnState = () => ({
  publishTime: [null, null], // 案例发布时间
  reviewTime: [null, null], // 审核日期
})

const ListFilter = (props) => {
  const { handleQuery } = props;
  const [filterParams, setFilterParams] = useSetState(getInitParams());
  const [ownState, setOwnState] = useSetState(getInitOwnState());

  const onQuery = () => {
    let params = {
      ...filterParams,
      page: 1,
    };

    if (params.caseId) {
      if (!reg.test(params.caseId)) {
        message.info('请输入案例数字ID');
        return;
      }

      params = {
        caseId: params.caseId,
        reviewStatus: ''
      };
      onReset(params);
      return;
    }

    handleQuery(params);
  }

  const onReset = (resetParams) => {
    const initParams = {
      ...getInitParams(),
      ...resetParams,
    };
    setFilterParams(initParams);
    setOwnState(getInitOwnState());

    handleQuery({
      ...initParams,
      page: 1,
    });
  }

  return (
    <div className='caseCheckFilter'>
      <div className='filterItem'>
        <span>案例ID：</span>
        <Input
          allowClear
          style={{ width: 125 }}
          placeholder="请输入"
          value={filterParams.caseId}
          onChange={(e) => setFilterParams({ caseId: e.target.value })}
        />
      </div>

      <div className='filterItem'>
        <ClassifyCascader
          value={filterParams.classifyId}
          onChange={(classifyId) => setFilterParams({ classifyId })}
        />
      </div>

      <div className='filterItem'>
        <span>状态：</span>
        <Select
          style={{ width: 120 }}
          value={filterParams.reviewStatus}
          onChange={(reviewStatus) => setFilterParams({ reviewStatus })}
        >
          {
            listStatusArr.map((item) => (
              <Option value={item.id} key={item.id}>{item.name}</Option>
            ))
          }
        </Select>
      </div>

      <div className='filterItem'>
        <span>案例发布时间：</span>
        <RangePicker
          value={ownState.publishTime}
          showTime={{ format: 'HH:mm:ss' }}
          format="YYYY/MM/DD HH:mm:ss"
          onChange={(publishTime) => {
            setOwnState({ publishTime });
            setFilterParams({
              startTime: publishTime[0]?.format?.(timeStyle),
              endTime: publishTime[1]?.format?.(timeStyle),
            })
          }}
        />
      </div>

      <div className='filterItem'>
        <span>审核人：</span>
        <Input
          allowClear
          style={{ width: 125 }}
          placeholder="请输入"
          value={filterParams.reviewAccountId}
          onChange={(e) => setFilterParams({ reviewAccountId: e.target.value })}
        />
      </div>

      <div className='filterItem'>
        <span>标题关键字：</span>
        <Input
          allowClear
          style={{ width: 125 }}
          placeholder="请输入"
          value={filterParams.title}
          onChange={(e) => setFilterParams({ title: e.target.value })}
        />
      </div>

      <div className='filterItem'>
        <span>授权类型：</span>
        <Select
          style={{ width: 120 }}
          value={filterParams.authorizationType}
          onChange={(authorizationType) => setFilterParams({ authorizationType })}
        >
          {
            authorizationTypeArr.map((item) => (
              <Option value={item.id} key={item.id}>{item.name}</Option>
            ))
          }
        </Select>
      </div>

      <div className='filterItem'>
        <span>来源：</span>
        <Select
          style={{ width: 120 }}
          value={filterParams.sourceType}
          onChange={(sourceType) => setFilterParams({ sourceType })}
        >
          {
            listSourceArr.map((item) => (
              <Option value={item.id} key={item.id}>{item.name}</Option>
            ))
          }
        </Select>
      </div>

      <div className='filterItem'>
        <span>审核日期：</span>
        <RangePicker
          value={ownState.reviewTime}
          showTime={{ format: 'HH:mm:ss' }}
          format="YYYY/MM/DD HH:mm:ss"
          onChange={(reviewTime) => {
            setOwnState({ reviewTime });
            setFilterParams({
              reviewStartTime: reviewTime[0]?.format?.(timeStyle),
              reviewEndTime: reviewTime[1]?.format?.(timeStyle),
            })
          }}
        />
      </div>

      <Button type="primary" onClick={() => onQuery()}>查询</Button>
      <Button type="primary" onClick={() => onReset()}>重置</Button>
    </div>
  );
}

export default ListFilter;